import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class WooCommerceCategoryMapApiClient extends AdvancedApiClient {

    static entityType = "WooCommerceCategoryMap"

    constructor(token, brandId, id) {
        super();

        this.setEntityType(WooCommerceCategoryMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/category/{cid}/woocommerce-map/{id}")
                .setRouteParam("cid", brandId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/category/{cid}/woocommerce-map")
                .setRouteParam("cid", brandId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}